import { applicantsRequests } from "@/src/api/applicantsRequests";
import type { AdmissionTaskPrefillPayload } from "@/src/hooks/useAdmissionTaskPrefill";
import { fetchAdmissionPrefillPayloadByApplicantId } from "@/src/utils/tasks/fetchAdmissionPrefillPayloadByApplicantId";

const normalizeEmail = (value: string) => value.trim().toLowerCase();

/**
 * Resolve applicant by email via GET /applicants/list?email=...,
 * then load full prefill payload the same way as Student Id.
 */
export const fetchAdmissionPrefillPayloadByEmail = async (
  email: string,
): Promise<AdmissionTaskPrefillPayload | null> => {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) return null;

  const list = await applicantsRequests.getList({ email: normalizedEmail, limit: 50, offset: 0 });
  if (!list.length) return null;

  const exactMatch =
    list.find((item) => normalizeEmail(String(item.email ?? "")) === normalizedEmail) ?? list[0];

  const applicantId = Number(exactMatch?.id);
  if (!Number.isFinite(applicantId) || applicantId <= 0) return null;

  return fetchAdmissionPrefillPayloadByApplicantId(applicantId);
};
